// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/core/svc_organization.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { CreateOrganizationReq, CreateOrganizationResp, DeleteOrganizationReq, DeleteOrganizationResp, OrganizationSettingsStreamReq, OrganizationSettingsStreamResp, SetOrganizationCommentReq, SetOrganizationCommentResp, SetOrganizationContactsReq, SetOrganizationContactsResp, SetOrganizationLanguageReq, SetOrganizationLanguageResp, SetOrganizationMFARequirementReq, SetOrganizationNameReq, SetOrganizationNameResp, SetOrganizationPrintNameReq, SetOrganizationPrintNameResp, SetOrganizationSettingsReq, SetOrganizationSettingsResp, SetOrganizationStaffJobPositionsReq, SetOrganizationStaffJobPositionsResp, SetOrganizationStaffMFARequirementReq, SetOrganizationStaffNameReq, SetOrganizationStaffNameResp, SetOrganizationTypeReq, SetOrganizationTypeResp } from "./svc_organization_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * Common errors:
 * - type: RequiredArgumentMissingError, Argument: OrganizationID
 * - type: NotFoundError, Entity: organization (if organization not found by OrganizationID)
 * - type: BadRequestError, Reason: organization deleted (if remote organization found by OrganizationID)
 *
 * @generated from service com.diagnocat.core.OrganizationService
 */
export const OrganizationService = {
  typeName: "com.diagnocat.core.OrganizationService",
  methods: {
    /**
     * Get organization and organization's invitations
     *
     * Permission: `OrganizationPermissions.CanViewStaff`
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.OrganizationSettingsStream
     */
    organizationSettingsStream: {
      name: "OrganizationSettingsStream",
      I: OrganizationSettingsStreamReq,
      O: OrganizationSettingsStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Create new organization or organization branch
     * - Any user can create a new organization
     * - The user who created the new organization is automatically assigned the Owner role
     * - Only Owner or Admin can create branches
     * - If branches are created, then all Owner or Admin user roles are duplicated from the parent organization to the branch
     * - If `IsDistributor`/`DistributorParentID` is set, requires `User.CanManageDistributors`
     * - If `IsDSO`/`DSOParentID` is set, requires `User.CanManageDSO`
     *
     * Errors:
     * - type: BadRequestError, Reason: parent deleted (if remote organization found by `CreateOrganizationReq.ParentID`)
     * - type: PermissionDeniedError, Reason: you do not have organization permission `CanEditBranches` (if user create branch and does not have the appropriate permission)
     * - type: PermissionDeniedError, Entity: User, Reason: CanManageDistributors (if `IsDistributor`/`DistributorParentID` is set and the actor lacks the permission)
     * - type: PermissionDeniedError, Entity: User, Reason: CanManageDSO (if `IsDSO`/`DSOParentID` is set and the actor lacks the permission)
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.CreateOrganization
     */
    createOrganization: {
      name: "CreateOrganization",
      I: CreateOrganizationReq,
      O: CreateOrganizationResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set organization name
     *
     * Permission: `OrganizationPermissions.CanEditInfo`
     *
     * Errors:
     * - type: RequiredArgumentMissingError, Argument: Name
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationName
     */
    setOrganizationName: {
      name: "SetOrganizationName",
      I: SetOrganizationNameReq,
      O: SetOrganizationNameResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set organization print name
     *
     * `Organization.PrintName` is shown in printed/exported report headers;
     * empty value resets it, so reports fall back to `Organization.Name`
     *
     * Permission: `OrganizationPermissions.CanEditInfo`
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationPrintName
     */
    setOrganizationPrintName: {
      name: "SetOrganizationPrintName",
      I: SetOrganizationPrintNameReq,
      O: SetOrganizationPrintNameResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set organization type
     *
     * Permission: `OrganizationPermissions.CanEditInfo`
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationType
     */
    setOrganizationType: {
      name: "SetOrganizationType",
      I: SetOrganizationTypeReq,
      O: SetOrganizationTypeResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set organization contacts
     *
     * Permission: `OrganizationPermissions.CanEditInfo`
     *
     * Errors:
     * - type: RequiredArgumentMissingError, Argument: OrganizationID/Contacts - (if the corresponding argument is empty)
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationContacts
     */
    setOrganizationContacts: {
      name: "SetOrganizationContacts",
      I: SetOrganizationContactsReq,
      O: SetOrganizationContactsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set organization settings
     *
     * Permission: `OrganizationPermissions.CanEditSettings`
     *
     * Errors:
     * - type: RequiredArgumentMissingError, Argument: OrganizationID/Settings - (if the corresponding argument is empty)
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationSettings
     */
    setOrganizationSettings: {
      name: "SetOrganizationSettings",
      I: SetOrganizationSettingsReq,
      O: SetOrganizationSettingsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Sets whether the organization requires MFA from ALL its members.
     * Permission: `OrganizationPermissions.MFA_CanEdit`. 
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationMFARequirement
     */
    setOrganizationMFARequirement: {
      name: "SetOrganizationMFARequirement",
      I: SetOrganizationMFARequirementReq,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Sets the per-member MFA requirement.
     * Permission: `OrganizationPermissions.MFA_CanEdit`. 
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationStaffMFARequirement
     */
    setOrganizationStaffMFARequirement: {
      name: "SetOrganizationStaffMFARequirement",
      I: SetOrganizationStaffMFARequirementReq,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Set organization language
     *
     * `OrganizationSettings.Language` can only be changed via this method;
     * `SetOrganizationSettings` keeps the stored value
     *
     * Permission: `OrganizationPermissions.CanEditSettings`
     *
     * Errors:
     * - type: RequiredArgumentMissingError, Argument: OrganizationID/Language - (if the corresponding argument is empty)
     * - type: InvalidArgumentValueError, Argument: Language - (if the language code is not supported)
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationLanguage
     */
    setOrganizationLanguage: {
      name: "SetOrganizationLanguage",
      I: SetOrganizationLanguageReq,
      O: SetOrganizationLanguageResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set organization comment
     *
     * Permission: `OrganizationPermissions.CanEditComment`
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationComment
     */
    setOrganizationComment: {
      name: "SetOrganizationComment",
      I: SetOrganizationCommentReq,
      O: SetOrganizationCommentResp,
      kind: MethodKind.Unary,
    },
    /**
     * Mark organization as deleted using organization id
     * - this organization mark as deleted
     * - all invitations to this organization are closed
     * - all invitations to the patients/studies/reports of this organization are closed
     *
     * Permission: `OrganizationPermissions.CanEditInfo`
     *
     * Errors:
     * - type: BadRequestError, Reason: organization has alive patients
     * - type: BadRequestError, Reason: organization has employees
     * - type: BadRequestError, Reason: organization has branches
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.DeleteOrganization
     */
    deleteOrganization: {
      name: "DeleteOrganization",
      I: DeleteOrganizationReq,
      O: DeleteOrganizationResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set job positions of an organization staff member
     *
     * Permission: `OrganizationPermissions.CanEditStaff`
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationStaffJobPositions
     */
    setOrganizationStaffJobPositions: {
      name: "SetOrganizationStaffJobPositions",
      I: SetOrganizationStaffJobPositionsReq,
      O: SetOrganizationStaffJobPositionsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Set the name of an organization staff member
     *
     * Permission: `OrganizationPermissions.CanEditStaff`
     *
     * @generated from rpc com.diagnocat.core.OrganizationService.SetOrganizationStaffName
     */
    setOrganizationStaffName: {
      name: "SetOrganizationStaffName",
      I: SetOrganizationStaffNameReq,
      O: SetOrganizationStaffNameResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

